import { render } from "./QrCodeTwo.vue?vue&type=template&id=23ed1fa0"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/QrCodeTwo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23ed1fa0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23ed1fa0', __exports__)) {
    api.reload('23ed1fa0', __exports__)
  }
  
  module.hot.accept("./QrCodeTwo.vue?vue&type=template&id=23ed1fa0", () => {
    api.rerender('23ed1fa0', render)
  })

}


export default __exports__